import React from 'react';
import { CheckCircle, X } from 'lucide-react';

const vergleichData = [
  {
    kategorie: 'Tiefe der Bewertung',
    gutachten: 'Umfassende, detaillierte Schadensdokumentation',
    kva: 'Oberflächliche Schätzung'
  },
  {
    kategorie: 'Rechtliche Beweiskraft',
    gutachten: 'Hohe Beweissicherung vor Gericht',
    kva: 'Eingeschränkte Beweiskraft'
  },
  {
    kategorie: 'Wertminderung',
    gutachten: 'Wird ermittelt und dokumentiert',
    kva: 'Meist nicht enthalten'
  },
  {
    kategorie: 'Nutzungsausfall',
    gutachten: 'Wird berücksichtigt',
    kva: 'Meist nicht berücksichtigt'
  },
  {
    kategorie: 'Ersteller',
    gutachten: 'Unabhängiger Sachverständiger',
    kva: 'Werkstatt (eigeninteressiert)'
  }
];

export const VergleichSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Vergleich
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Gutachten vs. Kostenvoranschlag
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Die wichtigsten Unterschiede im Überblick
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-3xl p-8 lg:p-12 shadow-lg overflow-x-auto">
          <div className="min-w-[600px]">
            {/* Header */}
            <div className="grid grid-cols-3 gap-4 mb-6 pb-6 border-b border-gray-200">
              <div className="font-bold text-gray-900 text-lg"></div>
              <div className="font-bold text-brand-green text-lg text-center">Unfallgutachten</div>
              <div className="font-bold text-gray-500 text-lg text-center">Kostenvoranschlag</div>
            </div>

            {/* Rows */}
            {vergleichData.map((item, index) => (
              <div key={index} className="grid grid-cols-3 gap-4 py-4 border-b border-gray-100 last:border-0">
                <div className="font-semibold text-gray-900 text-[15px]">{item.kategorie}</div>
                <div className="text-gray-700 text-[15px] text-center">{item.gutachten}</div>
                <div className="text-gray-500 text-[15px] text-center">{item.kva}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-gray-500">
            <strong>Faustregel:</strong> Ab ca. 750€ Schadensumfang ist ein Gutachten empfehlenswert.
          </p>
        </div>
      </div>
    </section>
  );
};